<template>
  <div id="the-footer">
    <v-card>
      <v-footer dark padless="padless">
        <v-card
          flat
          tile
          width="100%"
          class="lighten-1 white--text text-center"
        >
          <v-card-text>
            <v-btn
              v-for="(account, i) in accounts"
              :key="i"
              :href="account.url"
              class="mx-3 white--text"
              icon
              target="_blank"
            >
              <v-icon size="24px">{{ account.icon }}</v-icon>
            </v-btn>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="white--text">
            ™ & &copy; {{ year }} —
            <strong>
              <a href="https://leanrevisions.com" class="white--text"
                >LeanRevisions</a
              >
            </strong>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "the-footer",
  data: () => ({
    year: new Date().getFullYear(),
    accounts: [
      {
        icon: "fab fa-facebook",
        url: "https://www.facebook.com/leanrevisions",
      },
      {
        icon: "fab fa-twitter",
        url: "https://twitter.com/LeanRevisions",
      },
      {
        icon: "fab fa-linkedin",
        url: "https://www.linkedin.com/company/lean-revisions/",
      },
      {
        icon: "fab fa-instagram",
        url: "https://www.facebook.com/leanrevisions",
      },
      {
        icon: "fab fa-youtube",
        url: "https://www.youtube.com/channel/UCHzuymfwNC6fdrI1wX94SDA",
      },
    ],
  }),
};
</script>
